export const BREAK_POINTS = Object.freeze({
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
})
